import { IonButton, IonIcon } from "@ionic/react";
import { logOutOutline } from "ionicons/icons";
import { send } from "../../utils/sockets/asyncSocket";
import { v4 as uuidv4 } from "uuid";
import {
  removeCapacitorPreference,
  setCapacitorPreference,
} from "../../utils/core-utils/capPreferencesUtils";
import { CapacitorPreferencesConstants } from "../Constants";
import config from "../../components/helpers/socket/config";

// @author E42303 Judhjit Ganguli

const LogoutButton: React.FC = () => {
  function handleLogout() {
    localStorage.setItem("loggedOut", "true");
    removeCapacitorPreference("accessToken");
    setCapacitorPreference(
      CapacitorPreferencesConstants.IS_LOGIN_COMPLETE,
      "false",
    );
    window.location.assign("/logout_success");
    send(config.socket.channels.TRADING, {
      action: "logoff",
      requestID: uuidv4(),
      type: "",
      payload: "",
    });
  }
  return (
    <IonButton
      data-testid="logout-button"
      onClick={handleLogout}
      expand="block"
      color="danger"
      className="custom_cmed_mobile_button"
    >
      <IonIcon slot="start" icon={logOutOutline} />
      Logout
    </IonButton>
  );
};

export default LogoutButton;
